import React, { FC } from 'react'
import { Flex } from '@chakra-ui/react'
import { useColor, Spinner, BodyBackgroundNuance } from '@rw1/shared-lib'

export const LayoutSpinner: FC = () => {
  const bgColor = useColor({ nuance: BodyBackgroundNuance.Clean, palette: 'body' })

  return (
    <Flex
      alignItems="center"
      backgroundColor={bgColor}
      h="100vh"
      justifyContent="center"
      left={0}
      padding={0}
      position="absolute"
      right={0}
      top={0}
      w="100vw"
      zIndex="overlay">
      <Spinner />
    </Flex>
  )
}
